import { CalloutType, createAndAppendCallout } from "../app";
import { cast, castOrNull } from "../tools";

export function registerPro6WorkflowFormListeners(scopeEl: HTMLElement) {
    const wfstudentoverzichtForm = castOrNull(scopeEl.querySelector("#wfstudentoverzicht"), HTMLFormElement);
    if (wfstudentoverzichtForm != null) {
        const wfstudentoverzicht_proces = cast(scopeEl.querySelector("#wfstudentoverzicht_proces"), HTMLSelectElement);
        const geeftotaaloverzicht = castOrNull(scopeEl.querySelector("#geeftotaaloverzicht"), HTMLButtonElement);
        const startwizard = castOrNull(scopeEl.querySelector("#startwizard"), HTMLButtonElement);
        
        function checkProcesValue() {
            if (geeftotaaloverzicht) {
                geeftotaaloverzicht.disabled = wfstudentoverzicht_proces.selectedIndex <= 0;
            }

            if (startwizard) {
                startwizard.disabled = wfstudentoverzicht_proces.selectedIndex <= 0;
            }
        }

        checkProcesValue();
        wfstudentoverzicht_proces.addEventListener("change", checkProcesValue);
    }
}

export function registerPortaalIntekenImportFormListeners(scopeEl: HTMLElement) {
    const fimportForm = castOrNull(scopeEl.querySelector("#fimport"), HTMLFormElement);
    if (fimportForm == null) {
        return;
    }

    const fimport_volgende = castOrNull(scopeEl.querySelector("#fimport_volgende"), HTMLButtonElement);
    const fimport_periode = castOrNull(scopeEl.querySelector("#fimport_periode"), HTMLSelectElement);

    function checkPeriode() {
        if (fimport_periode != null && fimport_volgende != null) {
            fimport_volgende.disabled = fimport_periode.value == "";
        }
    }

    checkPeriode();
    fimport_periode?.addEventListener("change", checkPeriode);

    const fimport_importdata2_volgende = castOrNull(scopeEl.querySelector("#fimport_importdata2_volgende"), HTMLElement);
    if (fimport_importdata2_volgende == null) {
        return;
    }

    const fimport_importdata2_aantalvelden = cast(scopeEl.querySelector("#fimport_importdata2_aantalvelden"), HTMLInputElement);

    fimport_importdata2_volgende.addEventListener("click",
        (e) => {
            const fimport_importdata2_nieuw = cast(scopeEl.querySelector("#fimport_importdata2_nieuw"), HTMLInputElement);
            const melding = validate(fimportForm, +fimport_importdata2_aantalvelden.value, fimport_importdata2_nieuw.value == "nee");

            createAndAppendCallout(melding, CalloutType.Danger);

            if (melding != "") {
                e.preventDefault();
            }
        });
            
    HideVanKey(fimportForm, +fimport_importdata2_aantalvelden.value);

    const fimport_importdata2_vankey = castOrNull(scopeEl.querySelector("#fimport_importdata2_vankey"), HTMLSelectElement);
    fimport_importdata2_vankey?.addEventListener("change", () => HideVanKey(fimportForm, +fimport_importdata2_aantalvelden.value));
}

function validate(form: HTMLFormElement, aantalvelden: number, update: boolean): string {
    let melding = '';

    //test op dubbele velden
    for (let i = 1; i <= aantalvelden; i++) {
        for (let j = i + 1; j <= aantalvelden; j++) {
            if ((form['vld' + i].value != '') && (form['vld' + i].value == form['vld' + j].value)) {
                const field = form['vld' + i] as HTMLInputElement;
                field.focus();
                melding = "U kunt niet 2x hetzelfde veld kiezen om gegevens te importeren.";
            }
        }
    }

    if (update) {
        //test of sleutelveld niet bijgewerkt wordt
        for (let i = 1; i <= aantalvelden; i++) {
            if (form['vld' + i].value != '' &&
                form['vld' + i].value == form.naarkey.value) {
                melding += 'U kunt de waarde van het gekozen sleutelveld niet bijwerken.';
            }
        }
    }

    return melding;
}

function HideVanKey(form: HTMLFormElement, aantalvelden: number) {
    if (form.vankey) {
        for (let j = 1; j <= aantalvelden; j++) {
            if (form.vankey.value == j) {
                form["vld" + j].style.visibility = 'hidden';
                form["vld" + j].value = '';
            } else {
                form['vld' + j].style.visibility = 'visible';
            }
        }
    }
}
